module.exports = __webpack_public_path__ + "static/media/bbb.04d96e07.png";